import PropTypes from "prop-types";
import { useState } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import MDBox from "theme/components/MDBox";

function CheckboxField({ displayName, fieldRef, options }) {
  const [isChecked, setIsChecked] = useState(false);
  // console.log(options);
  return (
    <MDBox>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
        }
        label={displayName}
      />
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={isChecked}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
CheckboxField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

CheckboxField.defaultProps = {
  options: null,
};

export default CheckboxField;
